// this file contains shared actions, that would otherwise cause circular dependency issues
// e.g. defined in Slice A which is imported into Slice B, but Slice A also imports Slice B

import { createAction } from '@reduxjs/toolkit'

export const dismissNotification = createAction('DISMISS_NOTIFICATION')
export const changeTab = createAction('CHANGE_TAB')
